import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

// eslint-disable-next-line @retailer-platform/archlint/no-empty-access-control -- TODO: add proper access control (CXPRA-134)
export const draftManagementAccessControl: DomainAccessControlConfig = {}
